import styled from 'styled-components';

export const SecondaryText = styled.div`
  color: var(--color-secondary-text);
`;
